<template>
  <div id="auswertung_land">
    <div class="row justify-content-center">
      <div class="col-3">
        <button class="btn btn-primary" @click="$store.dispatch('incReveal')">Next</button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-8 col-lg-6 mx-auto">
        <div class="list-group">
          <transition-group name="fade" tag="div">
          <router-link v-for="(land, index) in ranking" :key="land.LAND" :to="'detail/'+land.LAND" class="list-group-item list-group-item-action clearfix" v-show="index >= counter - revealed">
            <div class="row">
              <div class="col-3">
                <span>{{ index + 1 }}</span>
              </div>
              <div class="col-9">
                <h4 class="list-group-item-heading">{{ land.LAND }}</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-3 d-flex align-items-center justify-content-center">
                <img :src="land.FLAGGE" class="img-fluid" alt="flagge"/>
              </div>
              <div class="col-6">
                <p class="list-group-item-text">
                  {{ land.INTERPRET }} - {{ land.SONG }}
                  <br />
                  <span v-if="land.ESC_PUNKTE">{{ land.ESC_PUNKTE }} ESC-Punkte</span>
                  <span v-if="land.PUNKTE">{{ land.PUNKTE }} Punkte</span>
                  <span v-else>0 Punkte</span>
                </p>
              </div>
              <div class="col-3 d-flex align-items-center justify-content-center">
                  <img :src="land.ICON" class="img-fluid" alt="icon"/>
              </div>
            </div>
          </router-link>
          </transition-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  import config from '../config'

export default {
  watch: {
    auswertung() {
      this.getData();
    }
  },
  computed: {
    revealed() {
      return this.$store.getters.reveal;
    }
  },
  data () {
    return {
      ranking: [],
      auswertung: 'gesamtsieger',
      counter: 0
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      let token = this.$store.state.token;
      axios.get(config.apiServerAdress + '/'+this.auswertung, {headers: {'x-access-token': token}})
        .then(res => {
          const data = res.data;
          const rank = [];

          for (let key in data) {
            const r = data[key];
            rank.push(r);
          }
          this.ranking = rank;
          this.counter = rank.length;

          //setInterval(() => this.counter--, 2000);

        })
        .catch(error => {
          console.log(error);
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s
  }
  .fade-enter-from, .fade-leave-to {
    opacity: 0
  }
</style>
